"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetVerificationOutput = exports.StoredDocumentation = exports.SamplingSchema = exports.SampleAllSamplingSchema = exports.CriteriaSamplingSchema = exports.CriteriaSamplingConfigSchema = exports.AssetConfigSchema = exports.FieldConfigSchema = void 0;
const zod_1 = require("zod");
const DataTapeField_1 = require("./CreditAgreement/DataTapeField");
const Utils = __importStar(require("./Utils"));
exports.FieldConfigSchema = zod_1.z.object({
    receivableResponseTapeField: zod_1.z
        .string()
        .describe('Where in receivable response tape is this field?'),
    receivableDocumentionField: zod_1.z
        .string()
        .describe('Where in generated pdf answers is this field?'),
    comparisonFormula: zod_1.z
        .string()
        .describe('How should we compare. This formula can access baseFields/intermediateFields and documentation fields.'),
});
exports.AssetConfigSchema = zod_1.z.object({
    fields: zod_1.z.array(exports.FieldConfigSchema).describe('Fields to verify'),
});
exports.CriteriaSamplingConfigSchema = zod_1.z.object({
    name: zod_1.z.string().describe('Unique name for the criteria'),
    formula: zod_1.z.string().describe('Formula that resolves to boolean'),
    percentageRate: zod_1.z.number().optional().describe('Defaults to 1 if undefined'),
    maximum: zod_1.z
        .number()
        .optional()
        .describe('Maximum amount to sample, if undefined, no max is enforced'),
});
exports.CriteriaSamplingSchema = zod_1.z.object({
    type: zod_1.z.literal('criteria'),
    config: zod_1.z.object({
        criterion: zod_1.z
            .array(exports.CriteriaSamplingConfigSchema)
            .describe('Each criteria is independent, allows for multiple "buckets"'),
    }),
});
exports.SampleAllSamplingSchema = zod_1.z.object({
    type: zod_1.z.literal('sampleAll'),
    name: zod_1.z.string(),
});
exports.SamplingSchema = zod_1.z.discriminatedUnion('type', [
    exports.CriteriaSamplingSchema,
    exports.SampleAllSamplingSchema,
]);
var StoredDocumentation;
(function (StoredDocumentation) {
    StoredDocumentation.FieldDocumentationSchema = zod_1.z.object({
        fieldName: zod_1.z.string(),
        raw: zod_1.z.string().nullable(),
        error: zod_1.z.string().nullable(),
        value: Utils.PrimitiveStruct,
        confidence: zod_1.z.number(),
        pageNumber: zod_1.z.number(),
    });
    StoredDocumentation.DocumentSchema = zod_1.z.object({
        fields: zod_1.z.array(StoredDocumentation.FieldDocumentationSchema),
    });
})(StoredDocumentation || (exports.StoredDocumentation = StoredDocumentation = {}));
var AssetVerificationOutput;
(function (AssetVerificationOutput) {
    /**
     * Result of an asset document verification on a receivable field
     */
    AssetVerificationOutput.FieldResultSchema = zod_1.z.object({
        docSanitizedValue: zod_1.z.string(),
        docRawValue: zod_1.z.string(),
        verificationResult: zod_1.z.boolean(),
    });
    /**
     * A receivable field that has been run through verification
     *
     * `result` is `null` if receivable has not been verified against asset document (typically because no asset document uploaded)
     */
    AssetVerificationOutput.ReceivableFieldSchema = zod_1.z.object({
        field: zod_1.z.string(),
        loanTapeValue: zod_1.z.string(),
        formula: zod_1.z.string(),
        result: AssetVerificationOutput.FieldResultSchema.nullable(),
    });
    AssetVerificationOutput.VerificationStatusValues = [
        'Untested', // no document was uploaded
        'TextractFailed', // document failed to textract or sanitize
        'UnverifiedFailure', // textract succeeded but verification failed for 1 or more fields (no manual edit yet.)
        'VerifiedFailure', // verification failures confirmed by manual edits.
        'Passed', // verification passed
    ];
    AssetVerificationOutput.ReportEntryStatusIterable = [
        'passed',
        'failed',
        'finley_review', // status subtype of failure (UnverifiedFailure)
        'missing_raw_documentation',
        'missing_generated_documentation',
    ];
    AssetVerificationOutput.GeneratedDocumentationSchema = zod_1.z.object({
        id: zod_1.z.string(),
        // Unix timestamp in milliseconds epoch, use new Date(timestamp) to read, date.getTime() to write
        timestamp: zod_1.z.number(),
        // if CM left a note on the generated documentation
        note: zod_1.z.string(),
    });
    AssetVerificationOutput.ReceivableDocumentationSchema = zod_1.z.object({
        // raw documentations (represents a pdf file)
        rawId: zod_1.z.string(),
        // Unix timestamp in milliseconds epoch, use new Date(timestamp) to read, date.getTime() to write
        timestamp: zod_1.z.number(),
        // latest version of generated documentation corresponding for this raw documentation
        generatedDocumentation: AssetVerificationOutput.GeneratedDocumentationSchema.nullable(),
    });
    AssetVerificationOutput.VerificationStatusSchema = zod_1.z.enum(AssetVerificationOutput.VerificationStatusValues);
    /**
     * A receivable with verification results.
     */
    AssetVerificationOutput.ReceivableSchema = zod_1.z.object({
        finleyReceivableId: zod_1.z.string(),
        externalReceivableId: zod_1.z.string(),
        documentations: zod_1.z.array(AssetVerificationOutput.ReceivableDocumentationSchema),
        verificationStatus: AssetVerificationOutput.VerificationStatusSchema,
        fields: zod_1.z.array(AssetVerificationOutput.ReceivableFieldSchema),
        sampleConfigs: zod_1.z.array(zod_1.z.string()).nullable(), // null implies no sampling config exists
        sampled: zod_1.z.boolean().nullable(), // null implies no verification exists
    });
    AssetVerificationOutput.CURRENT_STORED_VERIFICATION_RESULT_SCHEMA_VERSION = 1;
    AssetVerificationOutput.StoredVerificationResultV1Schema = zod_1.z.object({
        // since this is stored as a json blob in db
        // we need to keep track of schema version
        // this basically tells us if the shape of the structure
        // is current or not, and if not, how to convert it to
        schemaVersion: zod_1.z.literal(1),
        // results for each field that
        // we were asked to verify.
        fields: zod_1.z.array(AssetVerificationOutput.ReceivableFieldSchema),
    });
    /**
     * Verification report for a specific reporting date spanning all versions of files uploaded for that reporting date
     *
     * This is to ensure capturing all newly assigned receivables across multiple versions of the master loan tape for the same reporting date
     */
    AssetVerificationOutput.ReportSchema = zod_1.z.object({
        reportingDate: zod_1.z.string(),
        receivables: zod_1.z.array(AssetVerificationOutput.ReceivableSchema),
        baseFieldConfigs: zod_1.z.array(DataTapeField_1.DataTapeField.BaseConfigSchema),
    });
})(AssetVerificationOutput || (exports.AssetVerificationOutput = AssetVerificationOutput = {}));
//# sourceMappingURL=AssetVerification.js.map